import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const Close = ({color = 'error', ...props} : SvgIconProps) => (
  <SvgIcon color={color} {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="61.192" height="61.193" viewBox="0 0 61.192 61.193">
      <g id="Groupe_5539" data-name="Groupe 5539" transform="translate(191.29 572.417) rotate(180)">
        <g id="Groupe_5540" data-name="Groupe 5540">
          <path id="Tracé_5724" data-name="Tracé 5724" d="M187.047,568.174l-52.707-52.707" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="6"/>
          <path id="Tracé_5725" data-name="Tracé 5725" d="M187.047,568.174l-52.707-52.707" transform="translate(702.515 381.127) rotate(90)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="6"/>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default Close;